import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-faq-one',
  templateUrl: './faq-one.component.html',
  styleUrls: ['./faq-one.component.css']
})
export class FaqOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
